export const queryKeys = {
    auth: {
        me: ["auth", "me"] as const,
    },
    customers: {
        all: ["customers"] as const,
        lists: () => [...queryKeys.customers.all, "list"] as const,
    },
    settings: {
        all: ["settings"] as const,
        rider: () => [...queryKeys.settings.all, "rider"] as const,
    },
    notifications: {
        all: ["notifications"] as const,
        lists: () => [...queryKeys.notifications.all, "list"] as const,
        list: (page: number, unreadOnly: boolean) =>
            [...queryKeys.notifications.lists(), page, unreadOnly] as const,
    },
};
